import React from "react";
import { AnimatePresence, motion } from "framer-motion"

import { BabylonBackground, Header, Wrapper, Footer, Text } from "../";

import styles from "./PageContent.module.scss";

const PageContent = ( { children } ) =>
{
    return (
        <>
        <BabylonBackground width={window.innerWidth} height={window.innerHeight}/>
        <Wrapper>
            <Header/>
            <AnimatePresence exitBeforeEnter>
            <motion.div className={styles.root} exit={{ opacity: 0 }}>
                {children}
            </motion.div>
            </AnimatePresence>
            <Footer>
                <Text type="body">Sergio Cosman Agraz &#9733; 2021</Text>
            </Footer>
        </Wrapper>
        </>
    )
}

PageContent.defaultProps = {};

export default PageContent;